import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getProviderPlan = createAsyncThunk("provdier/plans-list", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/plans-list`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.providerPlans);
    return res.data.providerPlans;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers info");
  }
});

const providerPlanSlice = createSlice({
    name: "providerPlans",
        initialState: {
          providersPlan: null,
          loading: false,
          error: null,
        },
        extraReducers: (builder) => {
          builder
            .addCase(getProviderPlan.pending, (state) => {
                state.loading = true;
            })
            .addCase(getProviderPlan.fulfilled, (state, action) => {
                state.providersPlan = action.payload;
                state.loading = false;
            })
            .addCase(getProviderPlan.rejected, (state, action) => {
                state.error = action.payload || "Failed to fetch providers plan"; 
                state.loading = false;
            })
    },
});

export default providerPlanSlice.reducer;